import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';

export default function Footer() {
  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/images/favicon bushifood.png" 
                alt="BushiFood Logo" 
                className="h-8 w-8 rounded-full"
              />
              <div>
                <h3 className="font-bushido font-bold gold-accent">BushiFood</h3>
                <p className="text-xs text-muted-foreground font-kanji">The Chef Samurai</p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              Sistema etico di recensione basato sui 7 Pilastri del Bushidō
            </p>
          </div>

          {/* I Pilastri */}
          <div className="space-y-4">
            <h4 className="font-semibold text-secondary">I Sette Pilastri</h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2">
                <span className="font-kanji text-secondary">義</span>
                <span>Giustizia</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="font-kanji text-secondary">勇</span>
                <span>Coraggio</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="font-kanji text-secondary">仁</span>
                <span>Compassione</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="font-kanji text-secondary">礼</span>
                <span>Rispetto</span>
              </div>
            </div>
          </div>

          {/* Navigazione */}
          <div className="space-y-4">
            <h4 className="font-semibold text-secondary">Navigazione</h4>
            <div className="space-y-2 text-sm">
              <Link to="/pilastri" className="block hover:text-secondary transition-colors">
                I Pilastri
              </Link>
              <Link to="/recensione" className="block hover:text-secondary transition-colors">
                Scrivi Recensione
              </Link>
              <Link to="/quiz" className="block hover:text-secondary transition-colors">
                Quiz Accreditamento
              </Link>
              <Link to="/ricerca" className="block hover:text-secondary transition-colors">
                Ricerca Locali
              </Link>
            </div>
          </div>

          {/* Info */}
          <div className="space-y-4">
            <h4 className="font-semibold text-secondary">Informazioni</h4>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>Brand: nero-rosso-oro</p>
              <p>Codice rituale: Rei & Makoto</p>
              <p className="font-kanji">誠実 - Sincerità</p>
              <p className="font-kanji">礼儀 - Cortesia</p>
            </div>
          </div>
        </div>

        <Separator className="my-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-sm text-muted-foreground">
            <p>© 2024 BushiFood. Tutti i diritti riservati.</p>
          </div>
          <div className="text-sm text-muted-foreground">
            <p>Autore: <span className="text-accent font-medium">Giovanni Burdi</span> - Creative Direction</p>
          </div>
        </div>
      </div>
    </footer>
  );
}